import { css } from '@huspy/styled-system/css';

const borderStyles = '1px solid #000';

const cellBase = {
  border: borderStyles,
  padding: '2',
  maxWidth: '20%',
  minWidth: '37mm',
  textAlign: 'left',
  wordBreak: 'break-all',
  overflowWrap: 'break-word',
  whiteSpace: 'normal',
};

const narrowCellBase = {
  border: borderStyles,
  padding: '0 6',
  maxWidth: '15%',
  minWidth: '32mm',
  fontSize: 'sm',
};

const editableTemplateStyles = {
  tableRow: css({
    pageBreakInside: 'avoid',
    pageBreakAfter: 'auto',
  }),
  financialTableCellHead: css({
    ...narrowCellBase,
    borderBottom: 'unset !important',
    paddingTop: '6',
    textAlign: 'start',
  }),
  financialTableCellData: css({
    ...narrowCellBase,
    borderTop: 'unset !important',
    paddingBottom: '6',
  }),

  offersTableCellHead: css({
    ...cellBase,
    textAlign: 'center',
  }),
  offersTableCellData: css({
    ...cellBase,
    fontWeight: 'normal',
  }),
  image: css({
    width: '35%',
    padding: '1',
    marginLeft: 'auto',
  }),
};

export default editableTemplateStyles;
